import { useRef } from 'react';

import IframeResizer from 'iframe-resizer-react'

import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { RootState } from '@share/utils';

import './style.scss';

export function IframeTours() {

  const { id } = useParams<{ id: string }>();

  const loginStore = useSelector((state: RootState) => state.loginStore);
  const account = loginStore?.account;

  const src = account?.ashevillePlayTours?.find((tour: any) => tour.title?.replace(/\s+/g, '-').toLowerCase().replace(/\.|\,/g, '') === id)?.url;

  const iframeRef = useRef(null)
  const mainRef = useRef(null)

  return (
    <div ref={mainRef} style={{ flex: '1', display: 'grid' }}>
      <IframeResizer
        log
        inPageLinks
        forwardRef={iframeRef}
        heightCalculationMethod="lowestElement"
        src={src}
        width='100%'
        height='100%'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' 
        scrolling={true}
        autoResize={true}
        style={{ paddingTop: '15px', paddingBottom: '15px' }}
      />
    </div>
  );
}
